import './theme_fixutaxi.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeFixutaxi implements ITheme {
    id: string = 'fixutaxi';
    matchIfHostNameContainsAny: string[] = ["fixutaxi."];
    name: string = 'Fixutaxi';
    cssClassName: string = 'theme_fixutaxi';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.register,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#050505',
        secondary: '#ffcb31',
        accent: '#ffcb31',
        warning: '#ffcb31',
        bottomNavColor: '#ffcb31',
    };
}
